import { Colors } from '@sigma-frontend-libs/commons'

import { buttonModes, icons, services, sizes } from '@/utils'

import button from '@/components/button'
import squircle from '@/components/icon/squircle'
import { baseClass } from '@/components/rules/utils'
import ruleActions from '@/components/services/tariffs/rules/rule/actions'
import ruleConditions from '@/components/services/tariffs/rules/rule/conditions'
import packets from '@/components/services/tariffs/rules/rule/packets'
import priceRanges from '@/components/services/tariffs/rules/rule/priceRanges'
import tag from '@/components/tag'

function renderHandle(h) {
  return h(
    squircle,
    {
      attrs: { id: 'drag_handle' },
      class: 'drag_handle',
      props: {
        icon: icons.drag_handle,
        size: sizes.medium,
        color: Colors.grey
      }
    }
  )
}
function renderTitle(h) {
  return h(
    tag,
    {
      props: {
        label: this.getTranslate(`${services.tariffs}.rule`, { rule: this.index + 1 }),
        size: sizes.huge,
        color: Colors.grey
      }
    }
  )
}
function renderHeader(h) {
  return h(
    'div',
    {
      class: `${services.tariffs}-rule__header`
    },
    [
      renderHandle.call(this, h),
      renderTitle.call(this, h)
    ]
  )
}

function renderActions(h) {
  return h(
    ruleActions,
    {
      props: {
        value: this.proxy,
        source: this.source
      },
      on: {
        input: event => {
          this.proxy = event
        }
      }
    }
  )
}

function renderRule(h, rule, index) {
  return h(
    ruleConditions,
    {
      props: {
        value: rule.conditions,
        type: this.source
      },
      key: index,
      on: {
        input: event => {
          this.updateRuleConditions(index, event)
        },
        remove: () => {
          this.removeRuleConditions(index)
        }
      }
    }
  )
}
function renderRules(h) {
  if (this.hasRules) {
    return h(
      'div',
      {
        class: `${services.tariffs}-rule__rules`
      },
      [
        this.proxy.rules.map((rule, index) => {
          return renderRule.call(this, h, rule, index)
        })
      ]
    )
  }
}
function renderPricesRanges(h) {
  return h(
    priceRanges,
    {
      props: {
        value: this.proxy.priceRanges
      },
      on: {
        input: event => {
          this.updatePriceRanges(event)
        }
      }
    }
  )
}
function renderPackets(h) {
  return h(
    packets,
    {
      props: {
        value: this.proxy.packets
      },
      on: {
        input: event => {
          this.proxy.packets = event
        }
      }
    }
  )
}
function renderRanges(h) {
  return h(
    'div',
    {
      class: `${services.tariffs}-rule__ranges`
    },
    [
      renderPricesRanges.call(this, h),
      renderPackets.call(this, h)
    ]
  )
}
function renderBody(h) {
  return h(
    'div',
    {
      class: `${services.tariffs}-rule__body`
    },
    [
      renderActions.call(this, h),
      renderRanges.call(this, h),
      renderRules.call(this, h)
    ]
  )
}

function renderRemoveRuleButton(h) {
  return h(
    button,
    {
      props: {
        label: this.getTranslate(`${baseClass}.buttons.remove.rule`),
        size: sizes.small,
        mode: buttonModes.flat,
        color: Colors.error
      },
      on: {
        click: () => {
          this.$emit('remove', this.index)
        }
      }
    }
  )
}
function renderAddGroupButton(h) {
  return h(
    button,
    {
      props: {
        label: this.getTranslate(`${baseClass}.buttons.add.group`),
        size: sizes.small,
        mode: buttonModes.flat,
        color: Colors.primary
      },
      on: {
        click: () => {
          this.addConditions()
        }
      }
    }
  )
}
function renderFooter(h) {
  return h(
    'div',
    {
      class: `${services.tariffs}-rule__footer`
    },
    [
      renderRemoveRuleButton.call(this, h),
      renderAddGroupButton.call(this, h)
    ]
  )
}

export default function(h) {
  return h(
    'div',
    {
      class: `${services.tariffs}-rule`
    },
    [
      renderHeader.call(this, h),
      renderBody.call(this, h),
      renderFooter.call(this, h)
    ]
  )
}
